module.exports = __webpack_public_path__ + "static/media/vectortwo.d25a3d10.svg";